import React, { useEffect, useState } from "react";
import ImgCards from "../Cards/ImgCards";
import ToggleBtn from "../button/ToggleBtn";
import { useLocation, useNavigate } from "react-router-dom";
import PrimaryBtn from "../button/PrimaryBtn";
import SecondaryBtn from "../button/SecondaryBtn";
import ExtraItems from "../Cards/ExtraItems";
import DeleteSwal from "../Swals/DeleteSwal";
import { FaArrowLeft } from "react-icons/fa";
import DecorativeSquares from "../ui/DecorativeSquares";
import { useDispatch, useSelector } from "react-redux";
import { X } from "lucide-react";
import {
  getAllMeals,
  onDeleteMeal,
  getExtraItems,
  onMealStatusUpdate,
  isExtraItemChecked,
  addNewExtraItem,
  onDeleteExtraItems,
} from "../../redux/thunks/mealsetupThunk";
import ImgCardSkeleton from "../Preloader/ImgCardSkeleton";
import toast from "react-hot-toast";
import ConfirmEditMeal from "../Modals/ConfirmEditMeal";
import Add from "../button/Add";
import ExtraListShimmer from "../Preloader/ExtraListShimmer";
import { encryptId } from "../../utils/urlCrypto";
import Pagination from "../Pagination";
import Search from "../form/Search";

const MealExternalPage = ({
  onNext,
  onAddMeal,
  onBack,
  isInternalFlow = false,
  mode = "setup",
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    isMealLoading,
    allMeals,
    isExtraLoading,
    getExtra: extraItems,
    currentPage,
    totalPages,
  } = useSelector((state) => state.setMeal);
  const [showExtraModal, setShowExtraModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [extraInputs, setExtraInputs] = useState([{ name: "", price: "" }]);
  // const [toggleState, setToggleState] = useState({});
  const [editExtra, setEditExtra] = useState({ name: "", amounts: "" });
  const [SelectedMealId, setSelectedMealId] = useState(null);
  const [editExtraId, setEditExtraId] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const currencySymbol = localStorage.getItem("currency");
  // Get extra items
  useEffect(() => {
    dispatch(getExtraItems({ page, search }));
  }, [dispatch, page, search]);

  const handleExtraToggleChange = (extraId, value) => {
    const payload = {
      extra_item_id: extraId,
      is_confirmed: 1,
      confirm: 1, // ✅ REQUIRED
    };

    // console.log("The payload of extra item is :", payload);

    dispatch(isExtraItemChecked(payload))
      .unwrap()
      .then((res) => {
        if (res.success) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
      })
      .catch(() => {
        toast.error("Failed to update status");
      });
  };

  const handleToggleChange = (mealId) => {
    dispatch(
      onMealStatusUpdate({
        meal_id: mealId,
        is_confirmed: 1,
      }),
    )
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        dispatch(getAllMeals());
      })
      .catch(() => {
        toast.error("Status update failed");
      });
  };

  const addExtraField = () => {
    setExtraInputs((prev) => [...prev, { name: "", price: "" }]);
  };
  const handleExtraChange = (index, field, value) => {
    setExtraInputs((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    );
  };
  const handleOndeteteExtra = (extraId) => {
    // alert("delete");
    DeleteSwal({
      entity: "Extra Item",
      title: "Delete Extra Item?",
      text: "Are you sure you want to delete this extra item?",
      note: "This item will be removed from all meal plans.",
      cancleColor: "",
      onConfirm: () => {
        const payload = {
          extra_item_id: extraId,
          is_confirmed: 1,
        };
        // console.log("The extra item delete payload is :", payload);
        dispatch(onDeleteExtraItems(payload))
          .unwrap()
          .then((res) => {
            toast.success(res.message);
            dispatch(getExtraItems({ page, search }));
          })
          .catch((err) => {
            toast.error(err?.message || "Delete failed");
          });
      },
    });
  };

  useEffect(() => {
    if (!showEditModal || !editExtraId) return;

    const foundExtra = extraItems.find((item) => item.id === editExtraId);

    if (foundExtra) {
      setEditExtra({
        name: foundExtra.name || "",
        amounts: foundExtra.amounts || "",
      });
    }
  }, [showEditModal, editExtraId, extraItems]);

  const openEditModal = (extra) => {
    setEditExtraId(extra.id);
    setShowEditModal(true);
  };

  const handleTabChange = (i) => {
    setTab(i);
    localStorage.setItem("meal_external_tab", i);
  };

  const [tab, setTab] = useState(() => {
    const savedTab = localStorage.getItem("meal_external_tab");
    return savedTab !== null ? Number(savedTab) : 0;
  });

  const handleGoBack = () => {
    // 🔁 INTERNAL SETUP FLOW
    if (isInternalFlow && onBack) {
      onBack();
      return;
    }

    // 🌍 ROUTE BASED FLOW
    if (location.state?.from === "profile") {
      navigate("/profile");
      return;
    }

    // 🛑 LAST RESORT (optional)
    navigate("/dashboard");
  };

  useEffect(() => {
    dispatch(getAllMeals())
      .unwrap()
      .then((res) => {
        // console.log("The res of getting all meals is :", res.data);
      });
  }, [dispatch]);

  useEffect(() => {
    if (allMeals?.length) {
      const mealNames = allMeals.map((m) => m.meal_name);
      // console.log("Meal Names:", mealNames);
    }
  }, [allMeals]);

  const onEditOpen = (mealId) => {
    setSelectedMealId(mealId);
    setIsEditOpen(true);
  };

  const onEditHandle = (mealId) => {
    // console.log("Editing meal ID:", mealId); // ✅ check
    navigate(`/profile/meals/edit-meal/${encryptId(mealId)}`, {
      state: { from: "meals" },
    });
  };

  const handleOnDetails = (mealId) => {
    // console.log("Editing meal ID:", mealId);
    navigate(`/meal-detail/${encryptId(mealId)}`);
  };

  const onNextMeal = () => {
    navigate("/profile/meals/add-new-meal");
  };

  const handleOndeleteMeal = (mealId) => {
    DeleteSwal({
      entity: "Meal plan",
      title: "Delete Meal Plan?",
      text: "Are you sure you want to delete this meal plan?",
      note: "Note: No Further Orders Can Be Booked For This Meal Plan.",
      onConfirm: () => {
        const payload = {
          meal_id: mealId,
          is_confirmed: 1,
        };
        dispatch(onDeleteMeal(payload))
          .unwrap()
          .then((res) => {
            toast.success(res.message);
            dispatch(getAllMeals());
          })
          .catch((err) => {
            toast.error(err?.message || "Delete failed");
          });
      },
    });
  };

  // API logics for extra items
  const handleonExtraEditSave = async () => {
    if (!editExtra.name || !editExtra.amounts) {
      toast.error("Name and price are required");
      return;
    }

    const payload = {
      extra_item_id: editExtraId,
      name: editExtra.name,
      amounts: editExtra.amounts,
    };

    try {
      const res = await dispatch(addNewExtraItem(payload)).unwrap();

      if (res.success) {
        toast.success(res.message || "Extra Item Updated");

        await dispatch(getExtraItems({ page, search }));

        setShowEditModal(false);
        setEditExtraId(null);
      } else {
        toast.error(res.message || "Update failed");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  const handleOnAddExtraItem = async () => {
    // remove empty rows
    const validItems = extraInputs.filter((item) => item.name && item.price);

    if (!validItems.length) {
      toast.error("Please add at least one extra item");
      return;
    }

    try {
      for (const item of validItems) {
        const payload = {
          name: item.name,
          amounts: item.price,
        };

        await dispatch(addNewExtraItem(payload)).unwrap();
      }

      toast.success("Extra item(s) added successfully");

      setShowExtraModal(false);
      setExtraInputs([{ name: "", price: "" }]);

      await dispatch(getExtraItems({ page, search }));
    } catch (err) {
      toast.error(err?.message || "Couldn't add extra item");
    }
  };

  return (
    <div className=" max-w-7xl mx-auto px-4 md:px-6 py-10">
      <DecorativeSquares />
      <div className="bg-transparent md:bg-white w-full max-w-7xl shadow-none rounded-2xl md:shadow-sm p-0 md:p-4">
        <div className="relative flex items-center h-10">
          {/* Back Button – Left */}
          <button
            onClick={handleGoBack}
            className="absolute left-0 flex items-center"
          >
            <FaArrowLeft className="text-lg" />
          </button>

          {/* Title – Center */}
          <h1 className="mx-auto text-[#191919] font-bold text-base md:text-lg lg:text-xl">
            Manage Meal Plan
          </h1>
        </div>
        <div className="flex  justify-between items-center">
          <div className="flex gap-6 border-b mb-6 mt-6">
            {["Meal Plans", "Extra Items"].map((t, i) => (
              <button
                key={i}
                onClick={() => handleTabChange(i)}
                className={`pb-2 ${
                  tab === i
                    ? "border-b-2 border-[#FF6943] text-[#FF6943]"
                    : "text-gray-500"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
          <div className="w-1/4">
            {mode === "edit" &&
              (tab === 1 ? (
                <>
                  <SecondaryBtn
                    btnName="Add extra items"
                    clickEvent={() => setShowExtraModal(true)}
                    extraClass="hidden md:block"
                  />
                  <Add
                    addClickEvent={() => setShowExtraModal(true)}
                    extraClasses="block md:hidden  ml-9 mb-2"
                  />
                </>
              ) : (
                <>
                  <SecondaryBtn
                    btnName="Add New Plan"
                    clickEvent={onNextMeal}
                    extraClass="hidden md:block"
                  />

                  <Add
                    addClickEvent={() => onNextMeal()}
                    extraClasses="block md:hidden  ml-9 mb-2"
                  />
                </>
              ))}
          </div>
        </div>

        {tab === 0 && (
          <>
            {isMealLoading ? (
              // Render shimmer cards while loading
              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-4">
                {Array(3)
                  .fill(0)
                  .map((_, i) => (
                    <ImgCardSkeleton key={i} />
                  ))}
              </div>
            ) : allMeals.length === 0 ? (
              <p className="text-center text-gray-500">No meals found</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-4">
                {allMeals.map((meal) => (
                  <ImgCards
                    key={meal.meal_id}
                    imgName={meal.meal_cover_image}
                    cardTitle={meal.meal_name}
                    subTitle={`${currencySymbol}${meal.trial_serving_cost}/Order`}
                    description={meal.meal_description}
                    availabilityData={meal.availability_data}
                    linkedto={() => handleOnDetails(meal.meal_id)}
                    editAction={() => onEditOpen(meal.meal_id)}
                    // ✅ PASS ID HERE
                    deleteAction={() => handleOndeleteMeal(meal.meal_id)}
                    toggleAction={
                      <ToggleBtn
                        isOn={meal.is_enabled === 1}
                        size={40}
                        onChange={(newValue) =>
                          handleToggleChange(meal.meal_id, newValue)
                        }
                      />
                    }
                  />
                ))}
              </div>
            )}
          </>
        )}

        {tab === 1 && (
          <>
            <p className="text-gray-400 text-sm text-center md:text-end mb-3">
              All Modifications are effective for new orders only. Previously
              placed orders remain unchanged
            </p>
            <input
              type="text"
              placeholder="Search extra items..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value); 
              }}
              className="w-full  px-4 py-2 border rounded-md outline-none"
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {isExtraLoading ? (
                Array(10)
                  .fill(0)
                  .map((_, i) => <ExtraListShimmer key={i} />)
              ) : extraItems.length === 0 ? (
                <div className="col-span-1 md:col-span-2 flex justify-center items-center py-10">
                  <p className="text-gray-500 text-center">
                    No Extra Items found
                  </p>
                </div>
              ) : (
                extraItems.map((extra) => (
                  <ExtraItems
                    key={extra.id}
                    itemName={extra.name}
                    orderAmount={extra.amounts}
                    editAction={() => openEditModal(extra)}
                    DeleteAction={() => handleOndeteteExtra(extra.id)}
                    toggleAction={
                      <ToggleBtn
                        isOn={extra.status === 1}
                        size={40}
                        onChange={(v) => handleExtraToggleChange(extra.id, v)}
                      />
                    }
                  />  
                ))
              )}
            </div>
            <Pagination
              current={currentPage}
              total={totalPages}
              onPageChange={setPage}
            />
          </>
        )}

        <div className="flex justify-center items-center md:justify-between flex-col sm:flex-col md:flex-row lg:flex-row space-y-4 mt-6">
          {/* LEFT BUTTON */}
          {mode === "setup" &&
            (tab === 1 ? (
              <SecondaryBtn
                btnName="Add extra items"
                clickEvent={() => setShowExtraModal(true)}
              />
            ) : (
              <SecondaryBtn
                btnName="Add New Plan"
                clickEvent={onAddMeal}
                extraClass={"mt-4"}
              />
            ))}

          {/* RIGHT BUTTON */}
          {mode === "setup" ? (
            <PrimaryBtn
              btnName="Continue to next step"
              clickEvent={() => {
                if (isInternalFlow && typeof onNext === "function") {
                  onNext(); // 🔥 Setup ko control de do
                }
              }}
              extraClass="mb-4"
            />
          ) : (
            ""
          )}
        </div>
      </div>
      {showExtraModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl w-full max-w-sm p-4 space-y-4">
            <div className="flex justify-between">
              <div>
                <h2 className="text-lg font-semibold text-center">
                  Add Extra Items
                </h2>
              </div>
              <div
                className="cursor-pointer"
                onClick={() => setShowExtraModal(false)}
              >
                <X size={17} className="font-bold" />
              </div>
            </div>
            {extraInputs.map((item, index) => (
              <div key={index} className="flex gap-2 items-center">
                <input
                  type="text"
                  placeholder="Item name"
                  value={item.name}
                  onChange={(e) =>
                    handleExtraChange(index, "name", e.target.value)
                  }
                  className="flex-1 px-3 py-2 border rounded-md text-sm"
                />

                <div className="flex items-center border rounded-md px-2">
                  {currencySymbol}{" "}
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) =>
                      handleExtraChange(index, "price", e.target.value)
                    }
                    className="w-12 py-1 text-right outline-none"
                  />
                </div>

                {index === extraInputs.length - 1 && (
                  <button
                    onClick={addExtraField}
                    className="bg-[#FF6943] text-white px-3 py-1 rounded-md"
                  >
                    +
                  </button>
                )}
              </div>
            ))}

            {/* ACTION */}
            <button
              onClick={handleOnAddExtraItem}
              className="w-full bg-[#FF6943] text-white py-2 rounded-lg"
            >
              Add Items
            </button>
          </div>
        </div>
      )}

      {isEditOpen && SelectedMealId && (
        <ConfirmEditMeal
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          onConfirm={() => {
            onEditHandle(SelectedMealId);
            setIsEditOpen(false);
          }}
        />
      )}

      {showEditModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl w-full max-w-sm p-4 space-y-4">
            <div className="flex justify-between">
              <div>
                <h2 className="text-lg font-semibold text-center">
                  Edit Extra Items
                </h2>
              </div>
              <div
                className="cursor-pointer"
                onClick={() => setShowEditModal(false)}
              >
                <X size={17} className="font-bold" />
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <input
                type="text"
                placeholder="Item name"
                value={editExtra.name}
                onChange={(e) =>
                  setEditExtra((p) => ({ ...p, name: e.target.value }))
                }
                className="flex-1 px-3 py-2 border rounded-md text-sm"
              />

              <div className="flex items-center text-start border rounded-md px-2">
                {currencySymbol}
                <input
                  type="number"
                  value={editExtra.amounts}
                  onChange={(e) =>
                    setEditExtra((p) => ({ ...p, amounts: e.target.value }))
                  }
                  className="w-12 py-1 text-right outline-none"
                />
              </div>
            </div>

            {/* ACTION */}
            <button
              onClick={handleonExtraEditSave}
              className="w-full bg-[#FF6943] text-white py-2 rounded-lg"
            >
              update Items
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MealExternalPage;
